import React from 'react';
import {
	Card,
	CardContent,
	Typography,
	Grid,
	List,
	ListItem,
	ListItemText,
	makeStyles,
	Chip
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	card: {
		marginBottom: theme.spacing(2),
	},
	metricItem: {
		textAlign: 'center',
		padding: theme.spacing(1),
	},
	metricValue: {
		fontSize: '1.5rem',
		fontWeight: 'bold',
		color: theme.palette.primary.main,
	},
	metricLabel: {
		fontSize: '0.875rem',
		color: theme.palette.text.secondary,
	},
	complexityChip: {
		marginTop: theme.spacing(1),
	},
	highComplexity: {
		backgroundColor: theme.palette.error.main,
		color: theme.palette.error.contrastText,
	},
	mediumComplexity: {
		backgroundColor: theme.palette.warning.main,
		color: theme.palette.warning.contrastText,
	},
	lowComplexity: {
		backgroundColor: theme.palette.success.main,
		color: theme.palette.success.contrastText,
	},
	nextStepItem: {
		marginBottom: theme.spacing(1),
	},
}));

const SummaryCard = ({ summary }) => {
	const classes = useStyles();

	if (!summary) {
		return null;
	}

	return (
		<Card className={classes.card}>
			<CardContent>
				<Typography variant="h6" gutterBottom>
					Project Summary
				</Typography>
				
				<Grid container spacing={2}>
					<Grid item xs={12} sm={6}>
						<div className={classes.metricItem}>
							<Typography className={classes.metricValue}>
								{summary.estimatedTranslationWords?.toLocaleString() || 0}
							</Typography>
							<Typography className={classes.metricLabel}>
								Estimated Translation Words
							</Typography>
						</div>
					</Grid>
					
					<Grid item xs={12} sm={6}>
						<div className={classes.metricItem}>
							<Chip
								label={summary.complexity || 'Unknown'}
								variant="outlined"
								className={`${classes.complexityChip} ${
									summary.complexity === 'High' ? classes.highComplexity : 
									summary.complexity === 'Medium' ? classes.mediumComplexity : 
									classes.lowComplexity
								}`}
							/>
							<Typography className={classes.metricLabel}>
								Complexity Level
							</Typography>
						</div>
					</Grid>
				</Grid>

				{/* Content Type */}
				{summary.contentType && (
					<div style={{ marginTop: 16 }}>
						<Typography variant="subtitle2" gutterBottom>
							Content Type
						</Typography>
						<Chip
							label={summary.contentType}
							variant="outlined"
							color="secondary"
						/>
					</div>
				)}

				{/* Recommended Next Steps */}
				{summary.recommendedNextSteps && summary.recommendedNextSteps.length > 0 && (
					<div style={{ marginTop: 24 }}>
						<Typography variant="subtitle1" gutterBottom>
							Recommended Next Steps
						</Typography>
						<List dense>
							{summary.recommendedNextSteps.map((step, index) => (
								<ListItem key={index} className={classes.nextStepItem}>
									<ListItemText
										primary={`${index + 1}. ${step}`}
										primaryTypographyProps={{ variant: 'body2' }}
									/>
								</ListItem>
							))}
						</List>
					</div>
				)}
			</CardContent>
		</Card>
	);
};

export default SummaryCard;
